var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResendInvitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_67933)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.86128,
    cy: 4.86128,
    r: 4.05952,
    fill: "#E5E9F0",
    stroke: "white",
    strokeWidth: 0.738095
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.60979 6.38947C3.55449 6.33411 3.52344 6.25906 3.52344 6.18081C3.52344 6.10257 3.55449 6.02752 3.60979 5.97216L5.46798 4.11397H4.21213C4.13382 4.11397 4.05872 4.08286 4.00334 4.02748C3.94797 3.97211 3.91686 3.89701 3.91686 3.8187C3.91686 3.74039 3.94797 3.66529 4.00334 3.60992C4.05872 3.55455 4.13382 3.52344 4.21213 3.52344H6.18055C6.25886 3.52344 6.33397 3.55455 6.38934 3.60992C6.44471 3.66529 6.47582 3.74039 6.47582 3.8187V5.78713C6.47582 5.86544 6.44471 5.94054 6.38934 5.99591C6.33397 6.05128 6.25886 6.08239 6.18055 6.08239C6.10225 6.08239 6.02714 6.05128 5.97177 5.99591C5.9164 5.94054 5.88529 5.86544 5.88529 5.78713V4.53127L4.0271 6.38947C3.97173 6.44476 3.89669 6.47582 3.81844 6.47582C3.7402 6.47582 3.66515 6.44476 3.60979 6.38947Z",
    fill: "#3C4657"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_67933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.3333,
    height: 10.3333,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendInvitation);
export default __webpack_public_path__ + "static/media/ResendInvitation.b5e3f0d363c6f79fea93ae1d8fbcc062.svg";
export { ForwardRef as ReactComponent };